

































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardDetailRiwayat from "@/components/pemeriksaan/riwayat/CardDetailRiwayat.vue";
import { storeRiwayat } from "@/store/modules/riwayat";
import { KodingRegisterRow } from "@/types/kodingIcd";

@Component({
  components: { CardDetailRiwayat }
})
export default class DialogLihatPemeriksaan extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ default: null }) readonly baris!: KodingRegisterRow | null;

  siap = false;

  get identitas(): string {
    if (!this.baris) return "";

    return [this.baris.pasien.sex, this.baris.umur]
      .filter(teks => !!teks)
      .join(" · ");
  }

  @Watch("value")
  onBuka(val: boolean) {
    this.siap = false;

    if (!val) return;

    storeRiwayat.resetForPasien();
    this.$nextTick(() => {
      this.siap = true;
    });
  }

  tutup() {
    this.$emit("input", false);
  }
}
